import React from 'react';

import ModalMask from './ModalMask/ModalMask';
import ModalDialog from './ModalDialog/ModalDialog';
import ModalHeader from './ModalHeader/ModalHeader';
import ModalFlyout from './ModalFlyout/ModalFlyout';

import * as styles from './Modal.module.scss';

interface propsInterface {
    children: React.ReactNode,
    centerContent?: boolean
}

const Modal = ({ children, centerContent }: propsInterface): JSX.Element => {
    const centeredClassName = centerContent ? styles.ModalCenterContent : '';

    return (
        <div className={`${styles.Modal} ${centeredClassName}`}>
            {children}
        </div>
    );
};

Modal.defaultProps = {
    centerContent: true
};

Modal.Mask = ModalMask;
Modal.Dialog = ModalDialog;
Modal.Header = ModalHeader;
Modal.Flyout = ModalFlyout;

export default Modal;
